import { render, staticRenderFns } from "./SuggestionSummary.vue?vue&type=template&id=7ad303d2&scoped=true"
import script from "./SuggestionSummary.vue?vue&type=script&lang=js"
export * from "./SuggestionSummary.vue?vue&type=script&lang=js"
import style0 from "./SuggestionSummary.vue?vue&type=style&index=0&id=7ad303d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad303d2",
  null
  
)

export default component.exports